import { useTranslation } from "react-i18next";
import { Button } from '@mui/material';
import ExcelJS from 'exceljs';

const EquipmentChecklistExcelDownload = ({excelDatas1, excelDatas2, title, filename}) => {
    const { t } = useTranslation();
    
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        horizontalCentered: true,
      },
    });
    ws.pageSetup.margins = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };
  
    let excelData = [];
    excelData.push(
      {
        data: [title],
      },
      {
        data: [],
      }
    );

    excelData.push({data : excelDatas1});

    excelDatas2.forEach((item, index) => {
        excelData.push({data : item});
    });

    excelData.push(
        {
            data: [t('message.common.text.how.to.write')],
        },
        {
            data: [t('message.common.text.how.to.write.checklist.one')],
        },
        {
            data: [t('message.common.text.how.to.write.checklist.two')],
        },
        {
            data: [t('message.common.text.how.to.write.checklist.three')],
        }
    );
    
    excelData.forEach((item, index) => {
      ws.getRow(index + 1).values = [...item.data];
    });
    
    let dataStartIdx = 4;
    // 셀 병합
    // title
    ws.mergeCells('A1:L1');

    // excelDatas1
    ws.mergeCells('B3:C3');
    ws.mergeCells('E3:G3');
    ws.mergeCells('H3:I3');
    ws.mergeCells('J3:L3');

    // excelDatas2 title
    ws.mergeCells('A4:A5');
    ws.mergeCells('B4:D5');
    ws.mergeCells('E4:J4');
    ws.mergeCells('K4:K5');
    ws.mergeCells('L4:L5');

    excelDatas2.forEach((item, index) => {
        if (index > 1) {
            ws.mergeCells('B'+(dataStartIdx)+':D'+(dataStartIdx));
        }
        dataStartIdx++;
    });

    ws.mergeCells('A'+(dataStartIdx)+':L'+(dataStartIdx));
    dataStartIdx++;
    ws.mergeCells('A'+(dataStartIdx)+':L'+(dataStartIdx));
    dataStartIdx++;
    ws.mergeCells('A'+(dataStartIdx)+':L'+(dataStartIdx));
    dataStartIdx++;
    ws.mergeCells('A'+(dataStartIdx)+':L'+(dataStartIdx));

    // 폰트 사이즈, 굵기, 색상 변경
    ws.getCell('A1').font = { size: 18, bold: true, color: { argb: '000000' } };

    ws.getCell('A3').font = { bold: true };
    ws.getCell('D3').font = { bold: true };
    ws.getCell('H3').font = { bold: true };

    ws.getCell('A4').font = { bold: true };
    ws.getCell('B4').font = { bold: true };
    ws.getCell('E4').font = { bold: true };
    ws.getCell('K4').font = { bold: true };
    ws.getCell('L4').font = { bold: true };

    ws.getCell('E5').font = { bold: true };
    ws.getCell('F5').font = { bold: true };
    ws.getCell('G5').font = { bold: true };
    ws.getCell('H5').font = { bold: true };
    ws.getCell('I5').font = { bold: true };
    ws.getCell('J5').font = { bold: true };

    ws.getCell('A3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('D3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('H3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };

    ws.getCell('A4').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('B4').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('E4').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('K4').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('L4').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };

    ws.getCell('E5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('F5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('G5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('H5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('I5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('J5').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };

    ws.getCell('A'+(4+excelDatas2.length)).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };

    // 정렬
    ws.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };

    ws.getCell('A3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('B3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('E3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('H3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('J3').alignment = { horizontal: 'center', vertical: 'middle' };

    excelDatas2 && excelDatas2.forEach((item, index) => {
        ws.getCell('A'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('B'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('C'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('D'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('E'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('F'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('G'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('H'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('I'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('J'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('K'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('L'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
    });

    ws.getCell('A'+(4+excelDatas2.length)).alignment =  { horizontal: 'center', vertical: 'middle' };
    
    // 테두리
    ws.getCell('A3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('B3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('D3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('E3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('H3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('J3').border = { top: { style: 'thin', color: { argb: '000000' } } };

    ws.getCell('A4').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('B4').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('E4').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('K4').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('L4').border = { top: { style: 'thin', color: { argb: '000000' } } };

    ws.getCell('A5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('B5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('E5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('F5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('G5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('H5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('I5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('J5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('K5').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('L5').border = { top: { style: 'thin', color: { argb: '000000' } } };
    
    excelDatas2 && excelDatas2.forEach((item, index) => {
      if (index === 2) {
        ws.getCell('A'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('B'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('E'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('F'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('G'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('H'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('I'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('J'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('K'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('L'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } } };
      }
      if (index > 2) {
        ws.getCell('A'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('B'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('E'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('F'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('G'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('H'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('I'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('J'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('K'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('L'+(4+index)).border = { top: { style: 'dotted', color: { argb: '000000' } } };
      }
    });

    ws.getCell('A'+(4+excelDatas2.length)).border =  { top: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('A'+(5+excelDatas2.length)).border =  { top: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('A'+(7+excelDatas2.length)).border =  { bottom: { style: 'thin', color: { argb: '000000' } } };

    // 가로 길이
    const col = [];
    for (let i = 0; i < 12; i++) {
        if (i <= 3 || i >=10) {
          col.push({
              key: 'data',
              width: 15,
          });
        } else {
          col.push({
            key: 'data',
            width: 7,
        });
        }
    }
    ws.columns = col;
  
    // 세로 길이
    for (let i = 1; i <= excelData.length; i++) {
      let row = ws.getRow(i);
      row.height = 22;
    }
  
    const download = () => {
        let promise = [];
        Promise.all(promise).then(() => {
            wb.xlsx.writeBuffer().then((b) => {
                let a = new Blob([b]);
                let url = window.URL.createObjectURL(a);
        
                let elem = document.createElement('a');
                elem.href = url;
                elem.download = filename;
                elem.click();
                elem.remove();
            });
        });
    }

    return (
        <Button variant="contained" color="primary" onClick={download} style={{margin:"3px"}}>
          {t('message.common.btn.excel.download')}
        </Button>
    )
};

export default EquipmentChecklistExcelDownload;